<template>
  <div
    class="marker-details"
    :class="{ 'marker-details--active': isMarkerDetailsActive }"
  >
    <button
      class="marker-details__handle"
      @click="toggleMenu"
    >
      <fa v-if="!isMarkerDetailsActive" :icon="['fas', 'ellipsis-h']" />
      <fa v-if="isMarkerDetailsActive" :icon="['fas', 'times']" />
    </button>
    <div class="marker-details__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isMarkerDetailsActive: false
    }
  },

  methods: {
    toggleMenu () {
      this.isMarkerDetailsActive = !this.isMarkerDetailsActive 
    },
  }
}
</script>

<style lang="scss" scoped>
.marker-details {
  background: rgba(255, 255, 255, .95);
  bottom: 0;
  min-width: 180px;
  padding: 8px;
  pointer-events: all;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(100%);
  transition: transform .2s ease-in-out;
  z-index: 260;

  &--active {
    transform: none;
  }

  &__handle {
    appearance: none;
    background: #3182ce;
    border: none;
    border-radius: 50%;
    color: #fff;
    font-size: 14px;
    height: 24px;
    left: -28px;
    position: absolute;
    top: 4px;
    width: 24px;

    &:hover {
      background: #2b6cb0;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
  }

  label {
    font-size: 11px;
  }
}
</style>
